import { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import OnboardingEmailInputsPanel from './OnboardingEmailInputsPanel';
import { OnboardingEmailModalProps } from './OnboardingEmailModal.props';
import { OnboardingEmailModalProvider } from './OnboardingEmailModalContext';
import OnboardingEmailOutputPanel from './OnboardingEmailOutputPanel';

const OnboardingEmailModal: FC<OnboardingEmailModalProps> = ({
  open,
  onClose,
  cmdId,
  measurementDateId,
  companyId,
  companyName,
  valuationId,
  valuationType,
}) => (
  <OnboardingEmailModalProvider
    open={open}
    cmdId={cmdId}
    measurementDateId={measurementDateId}
    companyId={companyId}
    companyName={companyName}
    valuationId={valuationId}
    valuationType={valuationType}
  >
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: 'min(1200px, 96vw)',
          maxWidth: '96vw',
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span>Draft Onboarding Email{companyName ? ` — ${companyName}` : ''}</span>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          <OnboardingEmailInputsPanel />
          <OnboardingEmailOutputPanel />
        </Box>
      </DialogContent>
    </Dialog>
  </OnboardingEmailModalProvider>
);

export default OnboardingEmailModal;
